var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc20ThumbUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M5 18a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h1.352l1.2-4.342a3 3 0 0 1 2.485-1.651l.2-.007h.263a2.5 2.5 0 0 1 2.495 2.336L13 4.5V8h1.998a3 3 0 0 1 2.972 3.415l-.03.173-1.2 4a3 3 0 0 1-2.764 2.407l-.178.005H5Zm1-8H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1v-6Zm4.5-6h-.264a1 1 0 0 0-.747.335l-.074.095-1.17 4.233a2 2 0 0 1-.14.362 1 1 0 0 0-.098.331L8 9.472V16h5.858a1 1 0 0 0 .951-.69l.075-.296 1.166-3.886.008-.119a1 1 0 0 0-.804-.99l-.097-.014-.099-.005H13a2 2 0 0 1-1.995-1.85L11 8V4.5a.5.5 0 0 0-.41-.492L10.5 4Z",
  clipRule: "evenodd"
})));
export default SvgIc20ThumbUp;